/* TTC's presentation contracts on the pinned Shopify Dawn runtime. */
(function () {
  'use strict';

  window.quickOrderListStrings = window.quickOrderListStrings || {
    min_error: 'The minimum quantity is [min].',
    max_error: 'The maximum quantity is [max].',
    step_error: 'Quantity must increase in steps of [step].'
  };

  const itemsClass = customElements.get('cart-items');
  if (itemsClass) {
    const originalChange = itemsClass.prototype.onChange;
    itemsClass.prototype.onChange = function (event) {
      const input = event.target;
      if (!input.matches('input.quantity__input[data-index]') || !/^[1-9]\d*$/.test(input.dataset.index)) return;
      if (!input.dataset.min) input.dataset.min = input.getAttribute('min') || '0';
      if (!input.getAttribute('step')) input.setAttribute('step', '1');
      return originalChange.call(this, event);
    };
    itemsClass.prototype.resetQuantityInput = function (index) {
      const input = document.getElementById('Quantity-' + index) || document.getElementById('Drawer-quantity-' + index);
      if (input) input.value = input.getAttribute('value');
      this.isEnterPressed = false;
    };
    const originalEnable = itemsClass.prototype.enableLoading;
    const originalDisable = itemsClass.prototype.disableLoading;
    itemsClass.prototype.enableLoading = function (line) {
      originalEnable.call(this, line);
      this.querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay').forEach(overlay => overlay.classList.remove('hidden'));
    };
    itemsClass.prototype.disableLoading = function (line) {
      originalDisable.call(this, line);
      this.querySelectorAll('#CartDrawer-Item-' + line + ' .loading-overlay').forEach(overlay => overlay.classList.add('hidden'));
    };
    const originalUpdate = itemsClass.prototype.onCartUpdate;
    itemsClass.prototype.onCartUpdate = function () {
      return this.tagName === 'CART-DRAWER-ITEMS' ? refreshDrawer() : originalUpdate.call(this);
    };
  }

  function bindOverlay(drawer) {
    const overlay = drawer.querySelector('#CartDrawer-Overlay');
    if (overlay && !overlay.dataset.ttcDawnClose) {
      overlay.dataset.ttcDawnClose = 'true';
      overlay.addEventListener('click', () => drawer.close());
    }
  }

  async function refreshDrawer() {
    const response = await fetch('/?sections=cart-drawer,cart-icon-bubble', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh cart');
    const sections = await response.json();
    const current = document.getElementById('CartDrawer');
    if (!current || !sections['cart-drawer']) return;
    const parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
    const fresh = parsed.getElementById('CartDrawer');
    if (!fresh) return;
    current.innerHTML = fresh.innerHTML;
    const drawer = current.closest('cart-drawer');
    const freshDrawer = parsed.querySelector('cart-drawer');
    if (drawer && freshDrawer) drawer.classList.toggle('is-empty', freshDrawer.classList.contains('is-empty'));
    if (drawer) bindOverlay(drawer);
    if (sections['cart-icon-bubble']) {
      const bubbleDocument = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const newBubble = bubbleDocument.querySelector('.cart-count-bubble');
      const currentIcon = document.getElementById('cart-icon-bubble');
      if (currentIcon) {
        currentIcon.querySelector('.cart-count-bubble')?.remove();
        if (newBubble) currentIcon.appendChild(newBubble);
      }
    }
    document.dispatchEvent(new CustomEvent('ttc:cart-rendered'));
  }

  const drawerClass = customElements.get('cart-drawer');
  if (drawerClass) {
    const originalRender = drawerClass.prototype.renderContents;
    drawerClass.prototype.renderContents = function (state) {
      if (state.sections?.['cart-drawer']) {
        const parsed = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
        const fresh = parsed.querySelector('cart-drawer');
        if (fresh) this.classList.toggle('is-empty', fresh.classList.contains('is-empty'));
      }
      const result = originalRender.call(this, state);
      bindOverlay(this);
      document.dispatchEvent(new CustomEvent('ttc:cart-rendered'));
      return result;
    };
  }

  const headerClass = customElements.get('header-drawer');
  if (headerClass) {
    const originalClose = headerClass.prototype.closeMenuDrawer;
    headerClass.prototype.closeMenuDrawer = function (event, focusTarget) {
      const summary = focusTarget || this.mainDetailsToggle.querySelector('summary');
      originalClose.call(this, event || new Event('close'), summary);
      summary?.setAttribute('aria-expanded', 'false');
    };
  }
  document.addEventListener('click', event => {
    const closeButton = event.target.closest('.menu-drawer__close-menu-btn');
    const drawer = closeButton?.closest('header-drawer');
    if (!drawer) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    drawer.closeMenuDrawer(event, drawer.mainDetailsToggle.querySelector('summary'));
  }, true);

  // The store's native legacy picker serializes full variants, rather than
  // Dawn's option-value IDs. Resolve its selected ID without changing pricing.
  function resolveVariant(variants, options) {
    return variants.find(variant => variant.options.length === options.length && variant.options.every((option, index) => option === options[index]));
  }
  document.addEventListener('change', async event => {
    const picker = event.target.closest('variant-selects');
    if (!picker || event.target.dataset.optionValueId || !picker.querySelector('script[type="application/json"]')) return;
    const json = picker.querySelector('script[type="application/json"]');
    let variants;
    try { variants = JSON.parse(json.textContent); } catch (_) { return; }
    if (!Array.isArray(variants)) return;
    event.stopImmediatePropagation();
    const requestToken = String(Number(picker.dataset.ttcVariantRequest || 0) + 1);
    picker.dataset.ttcVariantRequest = requestToken;
    const inputs = Array.from(picker.querySelectorAll('.product-form__input'));
    const options = inputs.map(input => input.querySelector('select')?.value || input.querySelector('input[type="radio"]:checked')?.value).filter(value => value !== undefined);
    const variant = resolveVariant(variants, options);
    const sectionId = picker.dataset.section;
    const product = picker.closest('product-info') || document.getElementById('MainProduct-' + sectionId);
    if (!product) return;
    product.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {
      input.value = variant?.id || '';
      input.disabled = !variant;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    const productForm = product.querySelector('product-form');
    productForm?.toggleSubmitButton?.(!variant || !variant.available, variant ? window.variantStrings.soldOut : window.variantStrings.unavailable);
    if (!variant) return;
    const url = new URL(picker.dataset.url, location.origin);
    if (url.origin !== location.origin) return;
    url.searchParams.set('variant', variant.id);
    url.searchParams.set('section_id', sectionId);
    const selectedId = String(variant.id);
    picker.dataset.ttcSelectedVariant = selectedId;
    try {
      const response = await fetch(url.pathname + url.search);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      if (picker.dataset.ttcVariantRequest !== requestToken) return;
      for (const prefix of ['price', 'Sku', 'Inventory', 'Volume', 'Quantity-Rules']) {
        const current = document.getElementById(prefix + '-' + sectionId);
        const fresh = html.getElementById(prefix + '-' + sectionId);
        if (current && fresh) current.innerHTML = fresh.innerHTML;
      }
      if (variant.featured_media) product.querySelector('media-gallery')?.setActiveMedia?.(sectionId + '-' + variant.featured_media.id, true);
      publish(PUB_SUB_EVENTS.variantChange, { data: { sectionId, html, variant } });
    } catch (_) {
      // The existing server-rendered product remains available for a retry.
    }
  }, true);

  if (!customElements.get('products-mega-menu')) {
    customElements.define('products-mega-menu', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const details = this.querySelector('details');
        const summary = details?.querySelector('summary');
        if (!details || !summary) return;
        const close = () => { details.removeAttribute('open'); summary.setAttribute('aria-expanded', 'false'); };
        this.closeMenu = close;
        const closeOthers = () => {
          document.querySelectorAll('products-mega-menu').forEach(menu => { if (menu !== this) menu.closeMenu?.(); });
          document.querySelectorAll('header-menu details[open]').forEach(menu => {
            menu.removeAttribute('open');
            menu.querySelector('summary')?.setAttribute('aria-expanded', 'false');
          });
        };
        details.addEventListener('toggle', () => { summary.setAttribute('aria-expanded', String(details.open)); if (details.open) closeOthers(); });
        this.addEventListener('mouseenter', () => { closeOthers(); details.setAttribute('open', ''); summary.setAttribute('aria-expanded', 'true'); });
        this.addEventListener('mouseleave', close);
        this.addEventListener('keyup', event => { if (event.key === 'Escape') { close(); summary.focus(); } });
        this.querySelector('.products-mega-menu__overlay')?.addEventListener('click', close);
        this.querySelectorAll('.products-mega-menu__item').forEach(item => item.addEventListener('mouseenter', () => {
          this.querySelectorAll('.products-mega-menu__item--active').forEach(active => active.classList.remove('products-mega-menu__item--active'));
          item.classList.add('products-mega-menu__item--active');
        }));
      }
    });
  }
  document.addEventListener('click', event => {
    if (!event.target.closest('products-mega-menu')) document.querySelectorAll('products-mega-menu').forEach(menu => menu.closeMenu?.());
  }, true);
  window.TTCDawnCompatibility = Object.freeze({ resolveVariant, refreshDrawer });
})();
